import { render, staticRenderFns } from "./KnowledgeItemForm.vue?vue&type=template&id=4f69b534&"
import script from "./KnowledgeItemForm.vue?vue&type=script&lang=js&"
export * from "./KnowledgeItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KnowledgeItemForm.vue"
export default component.exports